import React, { Component } from 'react';
// import { Redirect } from "react-router-dom";
import BottomBar from './sub-components/BottomBar';
import PhaserGame from './sub-components/PhaserGame'
import Message from './sub-components/Message'
import Overlay from './sub-components/Overlay'
import { Redirect } from 'react-router-dom';
// import AttractorTimeout from '../warning/attractorTimeout';

class TrackTheBallPhaser extends Component {
    state = {
        gameOver: false,
        redirect: false,
        levelNumber: 1,
        lives: this.props.config.screens.gameScreen.lives,
        timerRemaining: this.props.config.screens.gameScreen.level_timer_length,
        score: '00000',
        ballsFound: 0,
        messageText: this.props.config.screens.gameScreen.ball_select_message
    }

    componentDidMount() {
        const circle = document.querySelector('circle');
        const radius = circle.r.baseVal.value;
        const circumference = radius * 2 * Math.PI;

        circle.style.strokeDasharray = `${circumference} ${circumference}`;
        // circle.style.strokeDashoffset = `${circumference}`;
        circle.style.strokeDashoffset = 0;
    }

    startLevel = () => {
        const startButton = document.querySelector('.level-start');
        startButton.classList.add('hide');

        const phaserCanvas = document.getElementById('phaser-canvas');
        const startEvent = new Event('startGame');
        phaserCanvas.dispatchEvent(startEvent);

        const circle = document.querySelector('circle');
        const radius = circle.r.baseVal.value;
        const circumference = radius * 2 * Math.PI;

        const timer = document.querySelector('.timer');
        timer.classList.remove('hide');

        circle.style.transitionDuration = `${this.state.timerRemaining}s`;
        circle.style.strokeDashoffset = `${circumference}`;

        const timerInterval = setInterval(() => {
            this.timerTick(timerInterval)
        }, 1000);
    }

    timerTick = (interval) => {
        const { timerRemaining } = this.state;

        if (timerRemaining >= 1) {
            this.setState({
                timerRemaining: timerRemaining - 1
            })

            // Halfway through, turn all balls grey
            if (timerRemaining === Math.round(this.props.config.screens.gameScreen.level_timer_length) / 2) {
                const phaserCanvas = document.getElementById('phaser-canvas');
                const turnGrey = new Event('turnGrey');
                phaserCanvas.dispatchEvent(turnGrey);
            }

            if (timerRemaining === 1) {
                clearInterval(interval);

                const message = document.querySelector('.message');
                const timer = document.querySelector('.timer');
                const tracker = document.querySelector('.found-tracker');
                message.classList.remove('hide');
                timer.classList.add('hide');
                tracker.classList.remove('hide');

                const phaserCanvas = document.getElementById('phaser-canvas');
                const timerEnd = new Event('timerEnd');
                phaserCanvas.dispatchEvent(timerEnd);

                setTimeout(() => {
                    message.classList.add('hide');
                }, 2000)
            }
        }
    }

    setScore = (scoreType) => {
        let { score, levelNumber } = this.state;
        if (typeof score === 'string') {
            score = 0;
        }
        let points = 0;

        switch (scoreType) {
            case 'correct':
                points = this.props.config.screens.gameScreen.ball_correct_points * levelNumber;
                break;
            case 'incorrect':
                points = this.props.config.screens.gameScreen.ball_incorrect_points * levelNumber;
                break;
            case 'level':
                points = this.props.config.screens.gameScreen.level_finish_points * levelNumber;
                break;
            default:
                break;
        }

        score += points;
        this.setState({ score });

    }

    selectBall = (guessCorrect) => {
        const { lives, ballsFound, levelNumber } = this.state;
        const config = this.props.config.screens.gameScreen;
        const totalRedBalls = config.starting_red_balls + (config.level_increment_red_balls * (levelNumber - 1));

        const message = document.querySelector('.message');
        message.classList.add('hide');

        if (guessCorrect) {
            this.setScore('correct');
            this.setState({
                ballsFound: ballsFound + 1,
            })

            if (ballsFound + 1 === totalRedBalls) {

                this.setScore('level');

                setTimeout(() => {
                    const phaserCanvas = document.getElementById('phaser-canvas');
                    const levelComplete = new Event('levelComplete');
                    phaserCanvas.dispatchEvent(levelComplete);

                    const tracker = document.querySelector('.found-tracker');
                    const nextLevelButton = document.querySelector('.next-level');
                    const overlay = document.querySelector('.overlay');
                    tracker.classList.add('hide');
                    nextLevelButton.classList.remove('hide');
                    overlay.classList.remove('hide');
                }, 1000);
            }
        } else {
            this.setScore('incorrect');
            if (lives - 1 === 0) {

                const phaserCanvas = document.getElementById('phaser-canvas');
                const gameOver = new Event('gameOver');
                phaserCanvas.dispatchEvent(gameOver);

                this.setState({
                    gameOver: true,
                    lives: lives - 1
                }, () => {
                    const overlay = document.querySelector('.overlay');
                    const tracker = document.querySelector('.found-tracker');
                    const bottomBarBackground = document.querySelector('.bottom-bar .background');
                    overlay.classList.remove('hide');
                    tracker.classList.add('hide');
                    bottomBarBackground.classList.add('hide');
                })

                setTimeout(() => {
                    this.setState({
                        redirect: true,
                    })
                }, 5000);
            } else {
                this.setState({
                    lives: lives - 1
                })
            }
        }
    }

    loadNextLevel = () => {
        const nextLevelButton = document.querySelector('.next-level');
        const nextLevelOverlay = document.querySelector('.overlay');
        const startButton = document.querySelector('.level-start');
        nextLevelButton.classList.add('hide');
        nextLevelOverlay.classList.add('hide');
        startButton.classList.remove('hide');

        const circle = document.querySelector('circle');
        circle.style.strokeDashoffset = `0`;
        circle.style.transitionDuration = '0s';

        this.setState({
            levelNumber: this.state.levelNumber + 1,
            timerRemaining: this.props.config.screens.gameScreen.level_timer_length,
            ballsFound: 0
        }, () => {
            const phaserCanvas = document.getElementById('phaser-canvas');
            const nextLevel = new Event('nextLevel');
            phaserCanvas.dispatchEvent(nextLevel);
        })

    }

    render() {
        const config = this.props.config.screens.gameScreen;
        const { lives, levelNumber, timerRemaining, score, ballsFound, messageText, gameOver, redirect } = this.state;

        let overlayType;
        if (gameOver) {
            overlayType = 'game-over';
        } else {
            overlayType = 'level-complete';
        }

        return (
            <div className="ttb-game-area">

                {redirect &&
                    <Redirect push to={`/endgamescore?score=${score}&level=${levelNumber}`} />
                }

                <div className='level-start'>
                    <button onClick={this.startLevel}>
                        <span>{`Start level ${levelNumber}`}</span>
                    </button>
                </div>

                <Overlay config={config} type={overlayType} score={score} />

                <Message messageText={messageText} />

                <div className='next-level hide'>
                    <button onClick={this.loadNextLevel}>
                        <span>{config.next_level_button}</span>
                    </button>
                </div>

                <PhaserGame key={levelNumber} config={config} fullConfig={this.props.config} selectBall={this.selectBall} levelNumber={levelNumber} passRefUpward={this.props.passRefUpward}/>
                <BottomBar config={config} lives={lives} levelNumber={levelNumber} timerRemaining={timerRemaining} score={score} ballsFound={ballsFound}/>
            </div>
        );
    }
}

export default TrackTheBallPhaser;
